import { GetterTree, Getter } from 'vuex';
import { RootState } from '@/store/types';
import { PointageState } from './type';

export const getPointageEnCours: Getter<PointageState, RootState> = state => state.pointageEnCours;
export const getListTempsAccueil: Getter<PointageState, RootState> = state => state.listTempsAccueil;
export const getListSupplements: Getter<PointageState, RootState> = state => state.listSupplements;
export const getListTempsAccueilFiltred: Getter<PointageState, RootState> = state => state.listTempsAccueilFiltred;
export const getListSupplementsFiltred: Getter<PointageState, RootState> = state => state.listSupplementsFiltred;
export const getListPointagesPrevi: Getter<PointageState, RootState> = state => state.listPointagesPrevi;
export const getPaletteEnCours: Getter<PointageState, RootState> = state => state.paletteEncours;
export const getSupplementsActifs: Getter<PointageState, RootState> = state => state.listSupplementsActifs;
export const getLastAction: Getter<PointageState, RootState> = state => state.lastAction;
export const getIndividusPresents: Getter<PointageState, RootState> = state => state.individusPresents;
export const getIndividusFiltreesPresents: Getter<PointageState, RootState> = state => state.individusFiltreesPresents;
export const getVieQuoRegimeAli: Getter<PointageState, RootState> = state => state.vieQuoRegimeAli;

/* TAC */
export const getListSupplementsPrevi: Getter<PointageState, RootState> = state => state.listSupplementsPrevi;
export const getListPalettePresence: Getter<PointageState, RootState> = state => state.listPalettePresence;
export const getListPaletteAbsence: Getter<PointageState, RootState> = state => state.listPaletteAbsence;
export const getListGroupes: Getter<PointageState, RootState> = state => state.listGroupes;
export const getListRegim: Getter<PointageState, RootState> = state => state.listRegim;

export const getters: GetterTree<PointageState, RootState>={
    getPointageEnCours,
    getListTempsAccueil,
    getListPointagesPrevi,
    getPaletteEnCours,
    getListSupplements,
    getSupplementsActifs,
    getLastAction,
    getListSupplementsPrevi,
    getListPalettePresence,
    getListPaletteAbsence,
    getListGroupes, 
    getListRegim,
    getVieQuoRegimeAli,
    getIndividusPresents,
    getIndividusFiltreesPresents,
    getListTempsAccueilFiltred,
    getListSupplementsFiltred
}